export const CLOSE_LIGHTBOX = 'CLOSE_LIGHTBOX';
export const LIGHTBOX_CHANGE = 'LIGHTBOX_CHANGE';
export const OPEN_LIGHTBOX = 'OPEN_LIGHTBOX';


export const closeLightbox = () => ({ type: CLOSE_LIGHTBOX });
export const lightboxChange = ({ index }) => ({ type: LIGHTBOX_CHANGE, index });
export const openLightbox = ({ photoIndex, urls }) => ({ type: OPEN_LIGHTBOX, photoIndex, urls });
